import type {Transaction} from "prosemirror-state";
import {TableRect} from "prosemirror-tables";
import {Node} from "prosemirror-model";
import {TextSelection} from "prosemirror-state";

export const insertColumn = (tr: Transaction, tableRect: TableRect, targetPos: number, tableWidth: number) => {
    let {map, tableStart, table} = tableRect;
    for (let rowIndex = 0; rowIndex < map.height; rowIndex++) {
        const cells: Node[] = [];
        for (let e = 0; e < tableWidth; e++)
            cells.push(table.type.schema.nodes.tableDataCell.createAndFill()!);
        const l = map.positionAt(rowIndex, targetPos, table);
        tr.insert(tr.mapping.map(tableStart + l), cells)
    }
    const l = map.positionAt(0, targetPos, table);
    return tr.setSelection(TextSelection.near(tr.doc.resolve(tableStart + l)))
}